import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-list-values',
  templateUrl: './list-values.component.html',
  styleUrls: ['./list-values.component.sass']
})
export class ListValuesComponent implements OnInit {
  @ViewChild('scrollToBottom') private scroller: ElementRef;

  @Input() list = [];
  @Input() addToTop = true;
  @Input() placeholder = '';
  @Input() minSize = 0;
  @Input() disabled = false;
  @Output() listChange = new EventEmitter();

  newValue = '';

  constructor() { }

  ngOnInit() {
  }

  onDelete(index: number) {
    this.list.splice(index, 1);
    this.listChange.emit();
  }

  onAdd(e: any, entry: string) {
    e.preventDefault();

    if (entry.length > this.minSize) {
      this.newValue = '';

      if (this.addToTop) {
        this.list.unshift(entry);
      } else {
        this.list.push(entry);
        this.scrollToBottom();
      }
      this.listChange.emit();
    }
  }

  scrollToBottom() {
    try {
      setTimeout(() => {
        this.scroller.nativeElement.scrollTop = this.scroller.nativeElement.scrollHeight;
      });
    } catch (e) {}
  }
}
